webpackJsonp([2],{

/***/ 453:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(553)
  __webpack_require__(554)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(490),
  /* template */
  __webpack_require__(586),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6d22135f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 490:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_luxon__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['invoiceId', 'overview'],
  data: function data() {
    return {
      err: '',
      allDetails: null,
      webShopResources: [],
      webSpacePricing: [],
      moonLicensePricing: [],
      domainPricing: [],
      individualApp: [],
      restaurantApp: []
    };
  },

  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_3_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd');
    },
    objToArr: function objToArr(type) {
      if (!type) return [];
      var array = [];
      var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(type);
      keys.forEach(function (key) {
        return array.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, type[key]));
      });
      return array;
    }
  },
  created: function created() {
    var _this = this;

    this.$http.get('pricinggroupinvoice/' + this.invoiceId).then(function (res) {
      if (res.body.status === 'Success') {
        var details = res.body.details;
        _this.allDetails = details;
        if (details.webShopResourcePricing) {
          _this.webShopResources = details.webShopResourcePricing.map(function (data) {
            var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data.pricingPerSubscriptionModel);
            var pricingPerSubscriptionModel = keys.map(function (key) {
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data.pricingPerSubscriptionModel[key], {
                type: key
              });
            });
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, { pricingPerSubscriptionModel: pricingPerSubscriptionModel });
          });
        }
        if (details.webSpacePricing) {
          _this.webSpacePricing = details.webSpacePricing.map(function (data) {
            var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data.pricingPerWebSpaceType);
            var pricingPerWebSpaceType = keys.map(function (key) {
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data.pricingPerWebSpaceType[key], {
                type: key
              });
            });
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, { pricingPerWebSpaceType: pricingPerWebSpaceType });
          });
        }
        if (details.moonLicensePricing) {
          _this.moonLicensePricing = details.moonLicensePricing;
        }
        if (details.domainPricing) {
          _this.domainPricing = details.domainPricing.map(function (data) {
            var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data.pricingPerDomainType);
            var pricingPerDomainType = keys.map(function (key) {
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data.pricingPerDomainType[key], {
                type: key
              });
            });
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, { pricingPerDomainType: pricingPerDomainType });
          });
        }
        if (details.appResourcePricing) {
          if (details.appResourcePricing.individualOrderApp) {
            _this.individualApp = details.appResourcePricing.individualOrderApp.map(function (data) {
              var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data.appResourcePricingPerSubscriptionModel);
              var appResourcePricingPerSubscriptionModel = keys.map(function (key) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data.appResourcePricingPerSubscriptionModel[key], {
                  type: key
                });
              });
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, { appResourcePricingPerSubscriptionModel: appResourcePricingPerSubscriptionModel });
            });
          }
          if (details.appResourcePricing.restaurantOrderApp) {
            _this.restaurantApp = details.appResourcePricing.restaurantOrderApp.map(function (data) {
              var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data.appResourcePricingPerSubscriptionModel);
              var appResourcePricingPerSubscriptionModel = keys.map(function (key) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data.appResourcePricingPerSubscriptionModel[key], {
                  type: key
                });
              });
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, { appResourcePricingPerSubscriptionModel: appResourcePricingPerSubscriptionModel });
            });
          }
        }
        return;
      }
      _this.err = res.body.statusText;
    }, function (err) {
      _this.err = err.body.statusText || err.body.message;
    });
  }
});

/***/ }),

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(451)(true);
// imports


// module
exports.push([module.i, ".my-table-2 thead th{height:auto!important;padding:7px 10px!important}.my-table-2 tbody td{height:auto!important;padding:10px!important}.my-table-2 tbody td.nested{padding-left:30px!important}.my-table-2 tbody tr.total{border-top:2px solid #ffaf00!important}.my-table-2 tbody tr.spacing{height:20px}.my-table-2 .amount{width:250px}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/modals/InvoiceDetails.vue"],"names":[],"mappings":"AACA,qBACE,sBAAwB,AACxB,0BAA6B,CAC9B,AACD,qBACE,sBAAwB,AACxB,sBAAyB,CAC1B,AACD,4BACE,2BAA8B,CAC/B,AACD,2BACE,sCAAyC,CAC1C,AACD,6BACE,WAAa,CACd,AACD,oBACE,WAAa,CACd","file":"InvoiceDetails.vue","sourcesContent":["\n.my-table-2 thead th {\n  height: auto !important;\n  padding: 7px 10px !important;\n}\n.my-table-2 tbody td {\n  height: auto !important;\n  padding: 10px !important;\n}\n.my-table-2 tbody td.nested {\n  padding-left: 30px !important;\n}\n.my-table-2 tbody tr.total {\n  border-top: 2px solid #FFAF00 !important;\n}\n.my-table-2 tbody tr.spacing {\n  height: 20px;\n}\n.my-table-2 .amount {\n  width: 250px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(451)(true);
// imports


// module
exports.push([module.i, ".month-year p[data-v-6d22135f]{font-size:24px;color:#ffb300}.month-year span[data-v-6d22135f]{color:rgba(0,0,0,.67)}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/modals/InvoiceDetails.vue"],"names":[],"mappings":"AACA,+BACE,eAAgB,AAChB,aAAe,CAChB,AACD,kCACE,qBAA2B,CAC5B","file":"InvoiceDetails.vue","sourcesContent":["\n.month-year p[data-v-6d22135f] {\n  font-size: 24px;\n  color: #FFB300;\n}\n.month-year span[data-v-6d22135f] {\n  color: rgba(0, 0, 0, 0.67);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 553:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(527);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(452)("06129b12", content, true, {});

/***/ }),

/***/ 554:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(528);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(452)("7b3cb72c", content, true, {});

/***/ }),

/***/ 586:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "px-4 pb-4 pt-0",
    class: {
      'elevation-0': _vm.overview
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    staticClass: "month-year layout row wrap",
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "py-3 pr-3 ma-0"
  }, [_vm._v("\n        " + _vm._s(_vm.$lang.labels.company) + ":\n        "), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(_vm.allDetails.companyName))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-3 ma-0"
  }, [_vm._v("\n        " + _vm._s(_vm.$lang.labels.month) + ":\n        "), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(_vm.allDetails.month))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-3 ma-0"
  }, [_vm._v("\n        " + _vm._s(_vm.$lang.labels.year) + ":\n        "), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(_vm.allDetails.year))])])]), _vm._v(" "), (!_vm.overview) ? _c('v-btn', {
    attrs: {
      "flat": "",
      "fab": "",
      "small": "",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.err) ? _c('v-flex', {
    staticClass: "my-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.webShopResources.length > 0) ? _c('div', {
    staticClass: "v-table__overflow"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light my-table-2"
  }, [_c('tbody', [_vm._l((_vm.webShopResources), function(resource, index) {
    return [_c('tr', {
      key: index
    }, [_c('td', [_vm._v("\n              Webshop: \n              "), (resource.weShopResourceName) ? [_c('strong', [_vm._v(_vm._s(resource.weShopResourceName))])] : _vm._e(), _vm._v("\n              (" + _vm._s(resource.webShopResourceId) + ")\n            ")], 2), _vm._v(" "), _c('td')]), _vm._v(" "), _vm._l((resource.pricingPerSubscriptionModel), function(pricing, index) {
      return [_c('tr', {
        key: index
      }, [_c('td', [_vm._v("\n                Subscription: " + _vm._s(pricing.type) + "\n              ")]), _vm._v(" "), _c('td')]), _vm._v(" "), _vm._l((pricing.monthlySubscriptionPricing), function(subPricing, i) {
        return [_c('tr', {
          key: i
        }, [_c('td', {
          staticClass: "nested"
        }, [_vm._v("Time range (" + _vm._s(subPricing.noOfDaysCharged) + " days):")]), _vm._v(" "), _c('td', {
          staticClass: "amount"
        }, [_vm._v(_vm._s(_vm.formatDate(subPricing.fromDate)) + " - " + _vm._s(_vm.formatDate(subPricing.toDate)))])])]
      }), _vm._v(" "), _c('tr', {
        key: index
      }, [_c('td', {
        staticClass: "nested"
      }, [_vm._v("One time charges")]), _vm._v(" "), _c('td', {
        staticClass: "amount"
      }, [_vm._v(" " + _vm._s(pricing.onetimeCharges || 0) + " ")])]), _vm._v(" "), _vm._l((pricing.monthlySubscriptionPricing), function(monthly, index) {
        return (pricing.monthlySubscriptionPricing) ? [_c('tr', {
          key: index
        }, [_c('td', [_vm._v("Monthly Charges")]), _vm._v(" "), _c('td', {
          staticClass: "amount"
        }, [_vm._v(_vm._s(monthly.calculatedMonthlyCharge || 0))])]), _vm._v(" "), _c('tr', {
          key: index
        }, [_c('td', [_vm._v("Monthly subscription")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
          key: index
        }, [_c('td', {
          staticClass: "nested"
        }, [_vm._v("Fixed fee:")]), _vm._v(" "), _c('td', {
          staticClass: "amount"
        }, [_vm._v(_vm._s(monthly.monthlyFixedCharges ? monthly.monthlyFixedCharges : '0'))])])] : _vm._e()
      }), _vm._v(" "), (pricing.revenueBasedPricing) ? [_c('tr', {
        key: index
      }, [_c('td', {
        staticClass: "nested"
      }, [_vm._v("Charges on revenue: (total revenue " + _vm._s(pricing.revenueBasedPricing.totalRevenue) + ", \n                  number of orders " + _vm._s(pricing.revenueBasedPricing.noOfOrdersPlaced) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pricing.revenueBasedPricing.chargesOnRevenue))])])] : _vm._e()]
    }), _vm._v(" "), _c('tr', {
      key: index,
      staticClass: "total"
    }, [_c('td', [_c('strong', [_vm._v("Total for Resource")])]), _vm._v(" "), _c('td', {
      staticClass: "amount"
    }, [_vm._v(_vm._s(resource.totalCharges))])]), _vm._v(" "), _c('tr', {
      key: index,
      staticClass: "spacing"
    })]
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.moonLicensePricing.length > 0) ? _c('div', {
    staticClass: "v-table__overflow pt-4"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light my-table-2"
  }, [_c('tbody', [_vm._l((_vm.moonLicensePricing), function(license, index) {
    return [_c('tr', {
      key: index
    }, [_c('td', [_vm._v("Moon: (" + _vm._s(license.licenseId) + ")")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
      key: index
    }, [_c('td', [_vm._v("Subscription: " + _vm._s(license.licenseType))]), _vm._v(" "), _c('td')]), _vm._v(" "), _vm._l((license.license), function(pricing, index) {
      return [_c('tr', {
        key: index
      }, [_c('td', [_vm._v("Time range (" + _vm._s(pricing.noOfDaysCharged) + " days):")]), _vm._v(" "), _c('td', {
        staticClass: "amount"
      }, [_vm._v(_vm._s(_vm.formatDate(pricing.fromDate)) + " - " + _vm._s(_vm.formatDate(pricing.toDate)))])]), _vm._v(" "), _c('tr', {
        key: index
      }, [_c('td', [_vm._v("License:")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
        key: index
      }, [_c('td', {
        staticClass: "nested"
      }, [_vm._v("One time charges:")]), _vm._v(" "), _c('td', {
        staticClass: "amount"
      }, [_vm._v(_vm._s(pricing.licenseBase.onetimeCharges || 0))])]), _vm._v(" "), _c('tr', {
        key: index
      }, [_c('td', {
        staticClass: "nested"
      }, [_vm._v("Monthly charges:")]), _vm._v(" "), _c('td', {
        staticClass: "amount"
      }, [_vm._v(_vm._s(pricing.licenseBase.monthlyCharges || 0))])]), _vm._v(" "), _c('tr', {
        key: index
      }, [_c('td', [_vm._v("\n                Concurrent users (" + _vm._s(pricing.concurrentUsers.noOfConcurrentUsersCharged || 0) + " charged out of \n                " + _vm._s(pricing.concurrentUsers.noOfConcurrentUsersTotal || 0) + " total):\n              ")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
        key: index
      }, [_c('td', {
        staticClass: "nested"
      }, [_vm._v("One time charges:")]), _vm._v(" "), _c('td', {
        staticClass: "amount"
      }, [_vm._v(_vm._s(pricing.concurrentUsers.onetimeCharges))])]), _vm._v(" "), _c('tr', {
        key: index
      }, [_c('td', {
        staticClass: "nested"
      }, [_vm._v("Monthly charges:")]), _vm._v(" "), _c('td', {
        staticClass: "amount"
      }, [_vm._v(_vm._s(pricing.concurrentUsers.monthlyCharges))])])]
    }), _vm._v(" "), _c('tr', {
      key: index,
      staticClass: "total"
    }, [_c('td', [_c('strong', [_vm._v("Total for resources")])]), _vm._v(" "), _c('td', {
      staticClass: "amount"
    }, [_vm._v(" " + _vm._s(license.totalCharges) + " ")])]), _vm._v(" "), _c('tr', {
      key: index,
      staticClass: "spacing"
    })]
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.webSpacePricing.length > 0) ? _c('div', {
    staticClass: "v-table__overflow pt-4"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light my-table-2"
  }, [_c('tbody', [_vm._l((_vm.webSpacePricing), function(webspace, index) {
    return [_c('tr', {
      key: index
    }, [_c('td', [_vm._v("Webspace: (" + _vm._s(webspace.webSpaceId) + ")")]), _vm._v(" "), _c('td')]), _vm._v(" "), _vm._l((webspace.pricingPerWebSpaceType), function(pricing, index2) {
      return [_c('tr', {
        key: index2
      }, [_c('td', [_vm._v("Subscription: " + _vm._s(pricing.type))]), _vm._v(" "), _c('td')]), _vm._v(" "), _vm._l((pricing.monthlyWebSpaceTypePricing), function(webPricing, i) {
        return [_c('tr', {
          key: i
        }, [_c('td', {
          staticClass: "nested"
        }, [_vm._v("Time range (" + _vm._s(webPricing.noOfDaysCharged) + " days):")]), _vm._v(" "), _c('td', {
          staticClass: "amount"
        }, [_vm._v(_vm._s(_vm.formatDate(webPricing.fromDate)) + " - " + _vm._s(_vm.formatDate(webPricing.toDate)))])])]
      }), _vm._v(" "), _c('tr', {
        key: index2
      }, [_c('td', {
        staticClass: "nested"
      }, [_vm._v("One time charges:")]), _vm._v(" "), _c('td', {
        staticClass: "amount"
      }, [_vm._v(_vm._s(pricing.onetimeCharges || 0))])]), _vm._v(" "), _c('tr', {
        key: index2
      }, [_c('td', {
        staticClass: "nested"
      }, [_vm._v("Monthly charges:")]), _vm._v(" "), _c('td', {
        staticClass: "amount"
      }, [_vm._v(_vm._s(pricing.totalMonthlyCharges || 0))])])]
    }), _vm._v(" "), _c('tr', {
      key: index,
      staticClass: "total"
    }, [_c('td', [_c('strong', [_vm._v("Total for resources")])]), _vm._v(" "), _c('td', {
      staticClass: "amount"
    }, [_vm._v(_vm._s(webspace.totalCharges))])]), _vm._v(" "), _c('tr', {
      key: index,
      staticClass: "spacing"
    })]
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.domainPricing.length > 0) ? _c('div', {
    staticClass: "v-table__overflow pt-4"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light my-table-2"
  }, [_c('tbody', [_vm._l((_vm.domainPricing), function(domain, index) {
    return [_c('tr', {
      key: index
    }, [_c('td', [_vm._v("Domain: "), _c('strong', [_vm._v(_vm._s(domain.domainName))]), _vm._v(" (" + _vm._s(domain.domainId) + ")")]), _vm._v(" "), _c('td')]), _vm._v(" "), _vm._l((domain.pricingPerDomainType), function(pricing) {
      return [_vm._l((pricing.monthlyDomainTypePricing), function(monthly, index) {
        return [_c('tr', {
          key: index
        }, [_c('td', [_vm._v("Subscription: " + _vm._s(pricing.type))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
          key: index
        }, [_c('td', {
          staticClass: "nested"
        }, [_vm._v("Time range (" + _vm._s(monthly.noOfDaysCharged) + " days):")]), _vm._v(" "), _c('td', {
          staticClass: "amount"
        }, [_vm._v(_vm._s(_vm.formatDate(monthly.fromDate)) + " - " + _vm._s(_vm.formatDate(monthly.toDate)))])]), _vm._v(" "), _c('tr', {
          key: index
        }, [_c('td', {
          staticClass: "nested"
        }, [_vm._v("One time charges:")]), _vm._v(" "), _c('td', {
          staticClass: "amount"
        }, [_vm._v(_vm._s(monthly.monthlyFixedCharges || 0))])]), _vm._v(" "), _c('tr', {
          key: index
        }, [_c('td', {
          staticClass: "nested"
        }, [_vm._v("Monthly charges:")]), _vm._v(" "), _c('td', {
          staticClass: "amount"
        }, [_vm._v(_vm._s(monthly.calculatedMonthlyCharge || 0))])])]
      })]
    }), _vm._v(" "), _c('tr', {
      key: index,
      staticClass: "total"
    }, [_c('td', [_vm._v("Subtotal")]), _vm._v(" "), _c('td', {
      staticClass: "amount"
    }, [_vm._v(_vm._s(domain.totalChargesBeforeDiscount))])]), _vm._v(" "), (domain.discount) ? _c('tr', {
      key: index
    }, [_c('td', [_vm._v("Discount (" + _vm._s(domain.discountedDays) + " days)")]), _vm._v(" "), _c('td', {
      staticClass: "amount"
    }, [_vm._v("-" + _vm._s(domain.discount))])]) : _vm._e(), _vm._v(" "), _c('tr', {
      key: index,
      staticClass: "total"
    }, [_c('td', [_c('strong', [_vm._v("Total for resources")])]), _vm._v(" "), _c('td', {
      staticClass: "amount"
    }, [_vm._v(_vm._s(domain.totalCharges))])]), _vm._v(" "), _c('tr', {
      key: index,
      staticClass: "spacing"
    })]
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.individualApp.length > 0) ? _c('div', {
    staticClass: "v-table__overflow pt-4"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light my-table-2"
  }, [_c('tbody', [_vm._l((_vm.individualApp), function(resource, index) {
    return [_c('tr', {
      key: index
    }, [_c('td', [_vm._v("\n              App: \n              "), (resource.appResourceName) ? [_c('strong', [_vm._v(_vm._s(resource.appResourceName))])] : _vm._e(), _vm._v("\n              (" + _vm._s(resource.appResourceId) + ")\n            ")], 2), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
      key: index
    }, [_c('td', [_vm._v("Type: " + _vm._s(resource.appResourceType))]), _vm._v(" "), _c('td')]), _vm._v(" "), _vm._l((resource.appResourcePricingPerSubscriptionModel), function(pricing, index2) {
      return [_c('tr', {
        key: index2
      }, [_c('td', [_vm._v("Subscription: " + _vm._s(pricing.type))]), _vm._v(" "), _c('td')]), _vm._v(" "), _vm._l((pricing.monthlySubscriptionPricing), function(monthlyPricing, i) {
        return [_c('tr', {
          key: i
        }, [_c('td', {
          staticClass: "nested"
        }, [_vm._v("Time range (" + _vm._s(monthlyPricing.noOfDaysCharged) + " days):")]), _vm._v(" "), _c('td', {
          staticClass: "amount"
        }, [_vm._v(_vm._s(_vm.formatDate(monthlyPricing.fromDate)) + " - " + _vm._s(_vm.formatDate(monthlyPricing.toDate)))])])]
      }), _vm._v(" "), _c('tr', {
        key: index2
      }, [_c('td', {
        staticClass: "nested"
      }, [_vm._v("One time charges:")]), _vm._v(" "), _c('td', {
        staticClass: "amount"
      }, [_vm._v(_vm._s(pricing.onetimeCharges || 0))])]), _vm._v(" "), _vm._l((pricing.monthlySubscriptionPricing), function(monthly, index) {
        return (pricing.monthlySubscriptionPricing) ? [_c('tr', {
          key: index
        }, [_c('td', [_vm._v("Monthly Charges")]), _vm._v(" "), _c('td', {
          staticClass: "amount"
        }, [_vm._v(_vm._s(monthly.calculatedMonthlyCharge || 0))])]), _vm._v(" "), _c('tr', {
          key: index
        }, [_c('td', [_vm._v("Monthly subscription")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
          key: index
        }, [_c('td', {
          staticClass: "nested"
        }, [_vm._v("Fixed fee:")]), _vm._v(" "), _c('td', {
          staticClass: "amount"
        }, [_vm._v(_vm._s(monthly.monthlyFixedCharges ? monthly.monthlyFixedCharges : '0'))])])] : _vm._e()
      }), _vm._v(" "), (pricing.revenueBasedPricing) ? [_c('tr', {
        key: index2
      }, [_c('td', {
        staticClass: "nested"
      }, [_vm._v("Charges on revenue: (total revenue " + _vm._s(pricing.revenueBasedPricing.totalRevenue) + ", \n                  number of orders " + _vm._s(pricing.revenueBasedPricing.noOfOrdersPlaced) + ")")]), _vm._v(" "), _c('td', {
        staticClass: "amount"
      }, [_vm._v(_vm._s(pricing.revenueBasedPricing.chargesOnRevenue))])])] : _vm._e()]
    }), _vm._v(" "), _c('tr', {
      key: index,
      staticClass: "total"
    }, [_c('td', [_c('strong', [_vm._v("Total for Resource")])]), _vm._v(" "), _c('td', {
      staticClass: "amount"
    }, [_vm._v(_vm._s(resource.totalCharges))])]), _vm._v(" "), _c('tr', {
      key: index,
      staticClass: "spacing"
    })]
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.restaurantApp.length > 0) ? _c('div', {
    staticClass: "v-table__overflow pt-4"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light my-table-2"
  }, [_c('tbody', [_vm._l((_vm.restaurantApp), function(resource, index) {
    return [_c('tr', {
      key: index
    }, [_c('td', [_vm._v("\n              App: \n              "), (resource.appResourceName) ? [_c('strong', [_vm._v(_vm._s(resource.appResourceName))])] : _vm._e(), _vm._v("\n              (" + _vm._s(resource.appResourceId) + ")\n            ")], 2), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
      key: index
    }, [_c('td', [_vm._v("Type: " + _vm._s(resource.appResourceType))]), _vm._v(" "), _c('td')]), _vm._v(" "), _vm._l((resource.appResourcePricingPerSubscriptionModel), function(pricing, index2) {
      return [_c('tr', {
        key: index2
      }, [_c('td', [_vm._v("Subscription: " + _vm._s(pricing.type))]), _vm._v(" "), _c('td')]), _vm._v(" "), _vm._l((pricing.monthlySubscriptionPricing), function(monthlyPricing, i) {
        return [_c('tr', {
          key: i
        }, [_c('td', {
          staticClass: "nested"
        }, [_vm._v("Time range (" + _vm._s(monthlyPricing.noOfDaysCharged) + " days):")]), _vm._v(" "), _c('td', {
          staticClass: "amount"
        }, [_vm._v(_vm._s(_vm.formatDate(monthlyPricing.fromDate)) + " - " + _vm._s(_vm.formatDate(monthlyPricing.toDate)))])])]
      }), _vm._v(" "), _c('tr', {
        key: index2
      }, [_c('td', {
        staticClass: "nested"
      }, [_vm._v("One time charges:")]), _vm._v(" "), _c('td', {
        staticClass: "amount"
      }, [_vm._v(_vm._s(pricing.onetimeCharges || 0))])]), _vm._v(" "), _vm._l((pricing.monthlySubscriptionPricing), function(monthly, index) {
        return (pricing.monthlySubscriptionPricing) ? [_c('tr', {
          key: index
        }, [_c('td', [_vm._v("Monthly Charges")]), _vm._v(" "), _c('td', {
          staticClass: "amount"
        }, [_vm._v(_vm._s(monthly.calculatedMonthlyCharge || 0))])]), _vm._v(" "), _c('tr', {
          key: index
        }, [_c('td', [_vm._v("Monthly subscription")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
          key: index
        }, [_c('td', {
          staticClass: "nested"
        }, [_vm._v("Fixed fee:")]), _vm._v(" "), _c('td', {
          staticClass: "amount"
        }, [_vm._v(_vm._s(monthly.monthlyFixedCharges ? monthly.monthlyFixedCharges : '0'))])])] : _vm._e()
      }), _vm._v(" "), (pricing.revenueBasedPricing) ? [_c('tr', {
        key: index2
      }, [_c('td', {
        staticClass: "nested"
      }, [_vm._v("Charges on revenue: (total revenue " + _vm._s(pricing.revenueBasedPricing.totalRevenue) + ", \n                  number of orders " + _vm._s(pricing.revenueBasedPricing.noOfOrdersPlaced) + ")")]), _vm._v(" "), _c('td', {
        staticClass: "amount"
      }, [_vm._v(_vm._s(pricing.revenueBasedPricing.chargesOnRevenue))])])] : _vm._e()]
    }), _vm._v(" "), _c('tr', {
      key: index,
      staticClass: "total"
    }, [_c('td', [_c('strong', [_vm._v("Total for Resource")])]), _vm._v(" "), _c('td', {
      staticClass: "amount"
    }, [_vm._v(_vm._s(resource.totalCharges))])]), _vm._v(" "), _c('tr', {
      key: index,
      staticClass: "spacing"
    })]
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "v-table__overflow pt-2"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light my-table-2"
  }, [_c('tbody', [_c('tr', [_c('td', [_c('strong', [_vm._v("Total:")])]), _vm._v(" "), _c('td', {
    staticClass: "amount"
  }, [_c('strong', [_vm._v(_vm._s(_vm.allDetails.totalAmount) + " " + _vm._s(_vm.allDetails.currency === 'GBP' ? '£' : '€'))])])])])])])], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/2.c7feed56bfd98558a5f4.js